import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography } from '@mui/material';
import { ListItem, ListItemButton } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';

import CustomRowList from 'src/components/ui/list/custom-row-list';
import HeaderCellText from 'src/components/ui/list/header-cell-text';
import ListCellText from 'src/components/ui/list/list-cell-text';
import { useTrackingLogic } from 'src/hooks/myhooks/use-tracking-logic';

export const TrackingPhone = forwardRef((props, ref) => {
  const logic = useTrackingLogic(props);
  const item = props.item;

  const renderItem = (item, rowSx, idx) => (
    <ListItem divider={true} key={idx} disablePadding>
      <ListItemButton
        selected={item.optionId === logic.viewSelectedOptionId}
        onClick={() => logic.handleItemClicked(item)}
        sx={{
          px: 0.5,
          py: 1.5,
          flexDirection: 'column', // allow stacking left/right then bottom
          alignItems: 'stretch',   // so children expand full width
          ...(item.optionId === logic.viewSelectedOptionId && {
            bgcolor: 'primary.light',
            '&::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: 0,
              height: '100%',
              width: '2px',
              backgroundColor: 'primary.main',
            },
          }),
        }}
      >
      {/* Top row: left and right */}
      <Grid container>
        <Grid xs={7}>
          <ListCellText flex="1">
            <Typography variant="body1">{item.trackingName}</Typography>
            <Typography variant="body2" color="text.secondary">
              {item.remindDate}
            </Typography>
          </ListCellText>
        </Grid>
        <Grid xs={5}>
          <ListCellText flex="1" align="right">
            <Typography variant="body1">{item.statusName}</Typography>
            <Typography variant="body2" color="text.secondary">
              {item.updatedDate}
            </Typography>
          </ListCellText>
        </Grid>
      </Grid>

      {/* Bottom row: note (if any) */}
      {item.trackingNote?.trim() && (
        <Typography variant="body2">
          {item.trackingNote}
        </Typography>
      )}
    </ListItemButton>
  </ListItem>
  );

  return (
    <Card>
      <CardContent sx={{ px: 0, py: 1 }}>
        <Grid container spacing={2}>
          <Grid xs={12} md={4}>
              <ReadOnlyTextField label="Họ tên" value={item.name} />
          </Grid>

          <Grid xs={12} md={8}>
            <CustomRowList
              items={logic.trackingList} 
              renderItem={renderItem}
              sx={{
                height: '100%',
              }}
            >
              <HeaderCellText sx={{ width: '60%' }}>Tiến độ</HeaderCellText>
              <HeaderCellText sx={{ width: '40%', textAlign: 'right' }}>Trạng Thái</HeaderCellText>
            </CustomRowList>
            
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

TrackingPhone.propTypes = {
  item: PropTypes.object.isRequired,
};
